import settings from './settings.middleware.js'
import themes from './themes.middleware.js';
import anonymous from './anonymous.middleware.js';
import welfareVariant from './welfareVariant.middleware.js';
export default [
    settings,
    themes,
    anonymous,
    welfareVariant,
]